import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import enurl from "@/api/environment";
import Cookies from "js-cookie";
import artilce from "./vuex/article";
import sound from "./vuex/sound";
import video from "./vuex/video";
import announcement from "./vuex/announcement";
import library from "./vuex/library";
import lessonlearn from "./vuex/lessonlearn";
import companymanagement from "./vuex/companymanagement";
import course from "./vuex/course";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    artilce: artilce,
    sound: sound,
    video: video,
    announcement: announcement,
    library: library,
    lessonlearn: lessonlearn,
    course: course,
    companymanagement: {
      ...companymanagement,
      namespaced: true
    }
  },
  state: {
    status: "",
    token: sessionStorage.getItem("token") || "",
    userid: sessionStorage.getItem("userid") || "",
    usertype: sessionStorage.getItem("usertype") || "",
    username: sessionStorage.getItem("username") || "",
    //username: sessionStorage.getItem("fullName") || "",
    companyId: sessionStorage.getItem("companyId") || "",
    position: sessionStorage.getItem("position") || "",
    userImage: sessionStorage.getItem("userImage") || "",
    user: {}
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, user) {
      state.status = "success";
      state.token = user.token;
      state.userid = user.id;
      state.companyId = user.companyId;
      state.position = user.positions;
      state.usertype = user.userType.trim();
      state.username = user.fullName.trim();
      state.fullName = user.fullName;
      state.userImage = user.image;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.userid = "";
      state.usertype = "";
      state.companyId = "";
      state.position = "";
      state.fullName = "";
      state.userImage = "";
    },
    saveUserImage(state, data) {
      state.userImage = data;
    },
    saveUserPosition(state, data) {
      state.position = data;
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${enurl.apiUrl}Login/LoginProductAdmin`,
          data: user,
          method: "POST"
        })
          .then(resp => {
            if (resp.data.status != 0) {
              commit("auth_error");
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("userid");
              sessionStorage.removeItem("usertype");
              sessionStorage.removeItem("username");
              sessionStorage.removeItem("fullName");
              sessionStorage.removeItem("position");
              sessionStorage.removeItem("userImage");
              reject(resp.data.message);
            } else {
              console.log(resp.data.data);
              const position = resp.data.data.positions;
              const token = resp.data.data.token;
              const userId = resp.data.data.id;
              const userType = resp.data.data.userType.trim();
              const user = resp.data.data;
              const userName = resp.data.data.fullName.trim();
              const companyId = resp.data.data.companyId;
              const fullName = resp.data.data.fullName;
              const user_image = resp.data.data.image;

              sessionStorage.setItem("token", token);
              sessionStorage.setItem("userid", userId);
              sessionStorage.setItem("usertype", userType);
              sessionStorage.setItem("username", userName);
              sessionStorage.setItem("companyId", companyId);
              sessionStorage.setItem("position", position);
              sessionStorage.setItem("fullName", fullName);
              sessionStorage.setItem("userImage", user_image);

              // Add the following line:
              //axios.defaults.baseURL = enurl.apiUrl;
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
              Cookies.set("tokenProduct", token);
              commit("auth_success", user);
              resolve(resp);
            }
          })
          .catch(err => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        commit("logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userid");
        sessionStorage.removeItem("usertype");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("fullName");
        sessionStorage.removeItem("position");
        sessionStorage.removeItem("userImage");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    usertype: state => state.usertype,
    userid: state => state.userid,
    authStatus: state => state.status,
    companyid: state => state.companyId,
    username: state => state.username,
    fullName: state => state.fullName,
    token: state => state.token,
    userImage(state) {
      return state.userImage;
    },
    position(state) {
      return state.position;
    }
  }
});
